<template>
  <div class="term-details">
    <div class="term-details__top-section">
      <h1 class="term-details__title">{{ title }}</h1>
      <a-visibility show :on="[$breakpoint.mobile]">
        <a-show-more
          :row-count="5"
          :row-height="24"
          :font-size="16"
          @expand="onExpand"
          @collapse="onCollapse"
        >
          <a-render-html
            :key="isTermExpanded"
            :html="termOfTheDayDescription"
            class="term-details__description"
          />
        </a-show-more>
      </a-visibility>
      <div class="term-details__suggest-a-term">
        <a-suggest-a-term :term-id="termId" :term-name="termName" />
        <a-lazy-hydrate when-visible>
          <a-action-icon
            :action-icon="ACTION_ICON.SHARE"
            :titleWidth="90"
            :title="title"
            height-auto
            :description="termTextDescription"
            :email-title="emailTitle"
            :email-description="emailDescription"
            :path="termPath"
          />
        </a-lazy-hydrate>
      </div>
    </div>

    <a-visibility hide :on="[$breakpoint.mobile]">
      <a-render-html
        :html="processHtml(description)"
        class="term-details__description"
      />
    </a-visibility>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import ASuggestATerm from '../ASuggestATerm'
import AActionIcon, { ACTION_ICON } from 'shared/AActionIcon'
import AShowMore from 'shared/AShowMore'
import { processHtml } from '@/utils/helpers/processHtml'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'

export default {
  name: 'ATermDetails',
  components: {
    ARenderHtml: hydrateWhenVisible(() => import('shared/ARenderHtml'), {
      props: ['html']
    }),
    ASuggestATerm,
    AActionIcon,
    AShowMore
  },
  props: {
    title: propValidator([PROP_TYPES.STRING]),
    description: propValidator([PROP_TYPES.STRING]),
    termId: propValidator([PROP_TYPES.STRING]),
    termName: propValidator([PROP_TYPES.STRING])
  },
  data() {
    return { ACTION_ICON, isTermExpanded: false }
  },
  computed: {
    termPath() {
      return this.$route.fullPath
    },
    termTextDescription() {
      return this.$helper.htmlToText(this.description)
    },
    emailTitle() {
      return `You’re going to love it: ${this.termName}`
    },
    emailDescription() {
      return `Check out this Term definition from Finance Magnates: ${this.$env.DOMAIN_URL}${this.termPath}`
    },
    termOfTheDayDescription() {
      const sanitizedHtml = processHtml(this.description)
      return this.isTermExpanded
        ? sanitizedHtml
        : this.$helper.htmlToText(sanitizedHtml)
    }
  },
  methods: {
    processHtml,
    onExpand() {
      this.isTermExpanded = true
    },
    onCollapse() {
      this.isTermExpanded = false
      this.$helper.scrollToTop(this)
    }
  }
}
</script>

<style lang="scss">
.term-details {
  width: 100%;
  position: relative;

  &__top-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @include desktop-md {
      align-items: baseline;
    }

    @include mobile {
      flex-direction: column;
    }
  }

  &__title {
    margin-bottom: 40px;

    @include mobile {
      margin-bottom: 10px;
    }
  }

  &__description {
    max-width: 100%;
    font-size: 16px;
    line-height: 1.5;
    font-weight: 300;
    overflow: hidden;
    height: auto;
  }

  &__suggest-a-term {
    max-width: 217px;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;

    @include mobile {
      position: relative;
      max-width: 100%;
      margin-top: 20px;
    }
  }
}
</style>
